import { render, staticRenderFns } from "./deliverAnnouncement.vue?vue&type=template&id=28b0f80f&scoped=true&"
import script from "./deliverAnnouncement.vue?vue&type=script&lang=js&"
export * from "./deliverAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./deliverAnnouncement.vue?vue&type=style&index=0&id=28b0f80f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0f80f",
  null
  
)

export default component.exports